// services/childcare/messages.js
import { api } from "./utils";

// Get all contacts
export const getContacts = async () => {
  try {
    const response = await api.get("/childcare/messages/contacts");
    return response;
  } catch (error) {
    console.error("Error fetching contacts:", error);
    throw error;
  }
};

// Get conversations
export const getConversations = async () => {
  try {
    const response = await api.get("/childcare/messages/conversations");
    return response;
  } catch (error) {
    console.error("Error fetching conversations:", error);
    throw error;
  }
};

// Get messages with user
export const getMessagesWithUser = async (userId) => {
  try {
    const response = await api.get(
      `/childcare/messages/conversation/${userId}`,
    );
    return response;
  } catch (error) {
    console.error("Error fetching messages:", error);
    throw error;
  }
};

// Send message - WITHOUT TOAST
export const sendMessage = async (messageData) => {
  try {
    const response = await api.post("/childcare/messages/send", messageData);
    return response;
  } catch (error) {
    console.error("Error sending message:", error);
    throw error;
  }
};

// Send bulk message
export const sendBulkMessage = async (bulkMessageData) => {
  try {
    const response = await api.post(
      "/childcare/messages/send-bulk",
      bulkMessageData,
    );
    return response;
  } catch (error) {
    console.error("Error sending bulk message:", error);
    throw error;
  }
};

// Mark message as read
export const markMessageAsRead = async (id) => {
  try {
    const response = await api.put(`/childcare/messages/${id}/read`);
    return response;
  } catch (error) {
    console.error("Error marking message as read:", error);
    throw error;
  }
};

// Delete message
export const deleteMessage = async (id, forEveryone = false) => {
  try {
    const url = forEveryone
      ? `/childcare/messages/${id}?for_everyone=true`
      : `/childcare/messages/${id}`;
    const response = await api.delete(url);
    return response;
  } catch (error) {
    console.error("Error deleting message:", error);
    throw error;
  }
};

// Delete conversation
export const deleteConversation = async (userId) => {
  try {
    const response = await api.delete(
      `/childcare/messages/conversation/${userId}`,
    );
    return response;
  } catch (error) {
    console.error("Error deleting conversation:", error);
    throw error;
  }
};

// Get shared media for conversation
export const getSharedMedia = async (userId, type = null) => {
  try {
    const params = type ? { type } : {};
    const response = await api.get(
      `/childcare/messages/shared-media/${userId}`,
      { params },
    );
    return response;
  } catch (error) {
    console.error("Error fetching shared media:", error);
    throw error;
  }
};

// Upload attachment
export const uploadAttachment = async (
  messageId,
  file,
  attachmentType = "file",
) => {
  try {
    const formData = new FormData();
    formData.append("message_id", messageId);
    formData.append("attachment_type", attachmentType);
    formData.append("file", file);

    const response = await api.post(
      "/childcare/messages/upload-attachment",
      formData,
      {
        headers: { "Content-Type": "multipart/form-data" },
      },
    );
    return response;
  } catch (error) {
    console.error("Error uploading attachment:", error);
    throw error;
  }
};

// Add link attachment
export const addLinkAttachment = async (messageId, linkData) => {
  try {
    const response = await api.post("/childcare/messages/add-link", {
      message_id: messageId,
      ...linkData,
    });
    return response;
  } catch (error) {
    console.error("Error adding link:", error);
    throw error;
  }
};

// Delete attachment
export const deleteAttachment = async (attachmentId) => {
  try {
    const response = await api.delete(
      `/childcare/messages/attachment/${attachmentId}`,
    );
    return response;
  } catch (error) {
    console.error("Error deleting attachment:", error);
    throw error;
  }
};

export const getUserBroadcasts = async () => {
  try {
    const response = await api.get("/childcare/messages/broadcasts");
    return response;
  } catch (error) {
    console.error("Error fetching broadcasts:", error);
    throw error;
  }
};

export const markBroadcastsRead = async () => {
  try {
    const response = await api.put("/childcare/messages/broadcasts/read");
    return response;
  } catch (error) {
    console.error("Error marking broadcasts read:", error);
    throw error;
  }
};

export const sendToAdmin = async (messageData) => {
  try {
    return await api.post("/childcare/messages/admin/send", messageData);
  } catch (error) {
    console.error("Error sending message to admin:", error);
    throw error;
  }
};

export const getMessagesWithAdmin = async (params = {}) => {
  try {
    return await api.get("/childcare/messages/admin/messages", { params });
  } catch (error) {
    console.error("Error fetching admin messages:", error);
    throw error;
  }
};
